// extracted by mini-css-extract-plugin
module.exports = {"cursor":"LimitedAccessBanner_cursor__24hNS","root":"LimitedAccessBanner_root__1P2hz","text":"LimitedAccessBanner_text__3b_9O","button":"LimitedAccessBanner_button__1n-HU"};